import captainPlan from "./captainPlan.component";

const captainPlanModule = angular
  .module("app.components.captainPlan", [])
  .component("captainPlan", captainPlan);

export default captainPlanModule;



// WEBPACK FOOTER //
// ./src/components/captainPlan/captainPlan.module.js